
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["sankey-demo-common","sankey-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Sankey__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.en.md?type=demo')
};